import { Page } from '@/core/architecture'

import { ConsoleDigitalMembershipCardDesignEditTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleDigitalMembershipCardDesignEdit Page
 * 会員証デザインを変更する画面
 */
export const ConsoleDigitalMembershipCardDesignEdit: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <ConsoleDigitalMembershipCardDesignEditTemplate
      state={state}
      {...actions}
    />
  )
}
